import BottomErrorBar from './BottomErrorBar';

export default BottomErrorBar;
